import React, { Component } from 'react'
import { Col, Form, Row } from 'antd'
import Employees from '../../../../../api/Employees'
import CurrencySelect from '../../../../../elements/Select/Currency'
import PayPeriodSelect from '../../../../../elements/Select/Employee/PayPeriod'
import _ from 'lodash'
import moment from 'moment/moment'
import Dropdowns from '../../../../../api/Dropdowns'
import Templates from '../../../../../api/Templates'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'
import Rates from './Rates'

const FormItem = Form.Item

class Payroll extends Component {
  uuid = moment().unix()

  constructor(props) {
    super(props)
    this.companyKey = (_.get(props, 'contract.company._id') || '').replace('members/', '')
    this.api = new Employees()
    this.key = props.employee._key
    this.dropdownApi = new Dropdowns()
    this.templateApi = new Templates()
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { contract, employee, type } = this.props

    return (
      <Form layout="horizontal">
        <Row>
          <Col span={12}>
            <FormItem label="Pay Period" {...formItemLayout}>
              {getFieldDecorator('pay.period', {
                initialValue: _.get(contract, 'pay.period'),
                rules: [
                  {
                    required: true,
                    message: "Pay Period can't be empty ",
                  },
                ],
              })(<PayPeriodSelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Pay Currency" {...formItemLayout}>
              {getFieldDecorator('pay.currency', {
                initialValue: _.get(contract, 'pay.currency'),
                rules: [
                  {
                    required: true,
                    message: "Pay Currency can't be empty ",
                  },
                ],
              })(<CurrencySelect />)}
            </FormItem>
          </Col>
        </Row>
        <Row />
        <Rates updateContract={this.props.updateContract} employee={employee} type={type} contract={contract} />
      </Form>
    )
  }
}

export default compose(Form.create(), withLoadingSection)(Payroll)
